import App from './app/reducer';
import Resource from './resource/reducer';
import Operation from './operation/reducer';

const exportedObject = {
	App,
	Resource,
	Operation
}

export default exportedObject
